export default __webpack_public_path__ + "static/media/icon_message.0e7d5205.svg";